
import { Component, Vue } from "vue-property-decorator";

interface MahkemeForm {
  davaDegeri: number | null;
  harcOrani: number | null;
  ekGiderler: number | null;
}

interface MahkemeResponse {
  harc_tutari: number;
  toplam_tutar: number;
}

@Component
export default class MahkemeHarciHesaplayici extends Vue {
  form: MahkemeForm = {
    davaDegeri: null,
    harcOrani: null,
    ekGiderler: null,
  };
  sonuc: MahkemeResponse | null = null;
  yukleniyor: boolean = false;
  genelHataMesaji: string | null = null;

  get formGecerli(): boolean {
    return (
        this.form.davaDegeri !== null &&
        this.form.davaDegeri >= 0 &&
        this.form.harcOrani !== null &&
        this.form.harcOrani >= 0
    );
  }

  // TL format
  tlFormat(sayi: number | null | undefined): string {
    if (sayi === null || sayi === undefined) return "";
    return sayi.toLocaleString("tr-TR", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  handleApiError(error: any) {
    if (error && error.response && error.response.data) {
      const data = error.response.data;
      if (data.errors) {
        const messages = Object.values(data.errors).flat();
        if (messages.length > 0) {
          this.genelHataMesaji = messages.join('\n');
          return;
        }
      }
      if (typeof data === "string") {
        this.genelHataMesaji = data;
      } else if (data.message) {
        this.genelHataMesaji = data.message;
      } else {
        this.genelHataMesaji = "Beklenmeyen bir hata oluştu.";
      }
    } else {
      this.genelHataMesaji = "Sunucuya ulaşılamadı.";
    }
  }

  async hesapla() {
    if (!this.formGecerli) return;
    this.yukleniyor = true;
    this.sonuc = null;
    this.genelHataMesaji = null;

    try {
      const response = await (this as any).$http.post(
          "/api/v1/hesaplayicilar/mahkeme-harc-gideri",
          {
            dava_degeri: this.form.davaDegeri,
            harc_orani: this.form.harcOrani,
            ek_giderler: this.form.ekGiderler,
          }
      );
      const data = response.data || response;
      this.sonuc = data;

    } catch (e) {
      this.handleApiError(e);
    } finally {
      this.yukleniyor = false;
    }
  }
}
